import GetListingMapMetaData from "./ListingMapMeta";

export default GetListingMapMetaData;
